import {InvoicePageVO, useQueryInvoicePage} from "@/service/invoice.s";
import React, {FC} from "react";
import {ProTable} from "@/widget/ProTable/ProTable";
import {GridColDef} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import {formatTime} from "@/helper/method";
import {InvoicePO} from "@/model/finance";

export interface InvoiceTableProps {
    customerId?: number;
    contractId?: number;
    data?: InvoicePO[];
    enabled?: boolean;
}

export const InvoiceTable: FC<InvoiceTableProps> = ({customerId, contractId, data, enabled}) => {
    const {
        mutate: invoicePageMutate,
        data: invoicePageData,
        isPending: invoicePagePending,
    } = useQueryInvoicePage()

    const invoiceColumns: GridColDef<InvoicePageVO>[] = [
        {
            field: "invoiceMoney",
            headerName: "开票金额",
            headerAlign: "left",
            align: "left",
            flex: 0.6,
            renderCell: ({row}) => <Box color={'red'} component={'span'}>{`￥${row.invoiceMoney}`}</Box>
        },
        {
            field: 'invoiceType',
            headerName: "开票类型",
            headerAlign: "center",
            align: "center",
            flex: 0.8,
        },
        {
            field: "invoiceNumber",
            headerName: "发票号码",
            headerAlign: "center",
            align: "center",
            flex: 1,
            valueFormatter: value => value || "-"
        }, {
            field: "createdAt",
            headerName: "开票日期",
            headerAlign: "center",
            align: "center", valueFormatter: (value) => formatTime("D", value),
        }]

    return <ProTable<InvoicePageVO> checkboxSelection={false} columnHeaderHeight={40} loading={invoicePagePending}
                                    onSearch={(params) => enabled && invoicePageMutate({...params, customerId, contractId})}
                                    data={invoicePageData?.data} pageSize={5} showToolbar={false} autoHeight={false}
                                    columns={invoiceColumns} source={{
        dataSource: {
            getRows: async () => {
                return {rows: data || [], rowCount: data?.length}
            }
        }, rowCount: data?.length || 0
    }}/>
}